import React, { Component } from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';

// Wrapper component to use hooks with class component
function ErrorBoundaryWrapper({ children }) {
  const location = useLocation();
  return <ErrorBoundary location={location}>{children}</ErrorBoundary>;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidUpdate(prevProps) {
    // Reset error state when location changes
    if (this.props.location !== prevProps.location && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch() {
    // Display fallback UI
    this.setState({ hasError: true });
    // console.log(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <h1>Une erreur s&apos;est produite</h1>
          <p>Contacter les administrateurs si cette erreur persiste.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  location: PropTypes.object,
  children: PropTypes.node,
};

ErrorBoundaryWrapper.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundaryWrapper;
